export const
    REPORTS_PENDING = 'reports_pending',
    REPORTS_FAILED = 'reports_failed',
    REPORTS_DOWNLOADED = 'reports_downloaded',
    REPORTS_RESET = 'reports_reset',
    REPORT_FOCUS = 'report_focus',
    REPORT_EDITING = 'report_editing',
    REPORT_DOWNLOADED = 'report_downloaded',
    REPORT_DELETING = 'report_deleting',
    REPORT_DELETED = 'report_deleted',
    REPORT_ITEM_POSTING = 'report_item_posting',
    REPORT_ITEM_DOWNLOADED = 'report_downloaded',
    REPORT_ITEM_PICTURE_POSTING = 'report_item_picture_posting',
    REPORT_ITEM_DELETING = 'report_item_deleting',
    REPORT_ITEM_DELETED = 'report_deleted';



// WEBPACK FOOTER //
// src/store/reports/types.js